import { render, staticRenderFns } from "./creat-button.vue?vue&type=template&id=4eca2e8c&scoped=true"
import script from "./creat-button.vue?vue&type=script&lang=js"
export * from "./creat-button.vue?vue&type=script&lang=js"
import style0 from "./creat-button.vue?vue&type=style&index=0&id=4eca2e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eca2e8c",
  null
  
)

export default component.exports